    <p-toolbar styleClass="width100p">
        <div class="toolbar-div width100p" [class.align-items-center]="center">
            <ng-content>
            </ng-content>
        </div>
    </p-toolbar>
